<template>
  <v-app>
    <Header/>
    <v-container>
      <v-row>
      <v-col :cols="12" :md="6"><Map/></v-col>
      <v-col :cols="12" :md="6"><EmbeddedResult />
      <Reply />
      <ResultInput />
      </v-col>
      </v-row>
    </v-container>
    <v-footer
    class="pt-6"
    color="rgb(255, 0, 0, 0)"
    >
    <v-col
      class="py-2 white--text text-center caption"
      cols="12"
    >
     本網頁是由中華民國數學會補助，<a target="_blank" class="white--text" href="https://www.andylee.tw">李昱勳</a>製作
    </v-col>
  </v-footer>
  </v-app>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Map from '@/components/MapSlide.vue'
import EmbeddedResult from "@/components/ResultSlide.vue";
import ResultInput from "@/components/ResultInput.vue";
import Reply from "@/components/Reply.vue";

export default {
  name: 'Home',
  components: {
    Header,
    Map,
    EmbeddedResult,
    ResultInput,
    Reply
  },
  mounted(){
      this.$vuetify.theme.dark = true;
  }
}
</script>